<template>
    <div>
        <div class="tabs">
            <div v-for="(item, index) in ['验收','待验收','已验收','历史纪录']"
            :class="selectIndex === index ? 'action' : ''"
                @click="SelectChange(index)">{{item}}</div>
        </div>
        <Box title="验收入库" :SearchParams="IsSee" @SearchParams="IsSee=true" :AddButton='true' @Other="Other">
            <div class="contentBox">
                <div v-if="selectIndex===0">
                  <keep-alive>
                       <CheckAndAccept :IsSee='IsSee' />
                  </keep-alive>
                </div>
                <div v-if="selectIndex===1">
                   <Acceptance :IsSee='IsSee' YSBZ='0' />
                    <!--未审核-->
                </div>
                <div v-if="selectIndex===2">
                    <!--已审核-->
                    <Acceptance :IsSee='IsSee' YSBZ='1' />
                </div>
                <div v-if="selectIndex===3">
                    <InStorageHistory :IsSee='IsSee' />
                </div>
            </div>
        </Box>
    </div>
</template>

<script>
    import Acceptance from '../../components/Acceptance/Acceptance.vue'
    import InStorageHistory from '../../components/StorageInspection/InStorageHistory.vue'
    import CheckAndAccept from '../../components/StorageInspection/CheckAndAccept.vue'
    import Footer from '../../components/footer/footer'
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'EquipmentAcceptance',
        data() {
            return {
                selectIndex: 0,
                dataDefault: {},
                list: [], //验收列表
                IsSee: false,
                search: {
                    HTMC: null,
                    GYSMC: null,
                    SBMC: null,
                    StartDate: null,
                    EndDate: null
                },
                Total: 0, //共计条数
                PageIndex: 1,
            }
        },
        props: {

        },
        components: {
            Box,
            Field,
            LoadingFooter,
            Footer,
            CheckAndAccept,
            InStorageHistory,
            Acceptance
        },
        activated() {
            this.$Bus.$on('IsSee', (_IsSee) => {
                this.IsSee = _IsSee;
            });
        },
        methods: {
            SelectChange(index) {
                this.selectIndex = index;
                this.IsSee = false;
            },
            Other() {
                let NowDate = this.$format(new Date(), 'YYYY-MM-DD');
                this.$router.push({
                    name: 'EquipmentAcceptanceDetails',
                    params: {
                        AcceptanceInfoList: {
                            ISDomestic: '0',
                            ISDomesticMC: '国产',
                            JJSBBZ: '0',
                            TZSBBZ: '0',
                            SFQJ: 'N',
                            GYSB: '0',
                            KJKM: '',
                            KJKMMC: '',
                            SFCYXYFX: 'N',
                            QDRQ: NowDate,
                            GRRQ: NowDate,
                            BXRQ: NowDate,
                            SSRQ: NowDate,
                            PJBZ: 'N',
                            zczj: 0,
                            kyjf: 0,
                            jxjf: 0,
                            jsjz: 0,
                            zfbk: 0,
                            rzzl: 0,
                            qt: 0,
                            SL: '',
                            CGDJ: '',
                            ZJE: 0,
                            HH: 0,
                            GLLB: ''
                        },
                        AZYS: [],
                        IsAddOrUpdata: false
                    }
                });
            }
        },
        watch: {

        }
    }
</script>
<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;
        transition: all .5s;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    // .tabs{

    // }

    .tabs {
        display: flex;
        align-items: center;
        background: #4FA69E;
        //border-radius: 14px 14px 0 0;
        position: fixed;
        z-index: 10;
        top: 105px;
        width: 100%;

        div {
            width: 177.5px;
            height: 96px;
            text-align: center;
            line-height: 96px;
            font-size: 28px;
            color: #FFFFFF;
            border-radius: 14px 14px 0 0;
        }

        .action {
            font-size: 5vw;
            //color: $THEME-COLOR;
            //background: #fff;
        }
    }

    .contentBox {
        margin-top: 105px;

        &>div {
            //padding: 0 30px;
            border-radius: 14px;
            background: #fff;
            margin-bottom: 30px;

            &:first-child {
                border-radius: 14px;
            }
        }
    }


    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-bottom: 20px;

        &>div {
            &:first-child {
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #EFEFEF;

                img {
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                }

                &>div {
                    &:nth-child(2) {
                        margin-left: 16px;

                        &>p {
                            color: $TEXT-DARK-COLOR;
                            font-weight: bold;
                            font-size: 32px;
                            margin-bottom: 18px;
                            width: 350px;
                        }

                        &>div {
                            display: flex;

                            p {
                                color: #999;
                                font-size: 26px;
                                line-height: 45px;
                                height: 45px;
                                width: 150px;
                            }

                            &>div {
                                &:last-child {
                                    p {
                                        width: 200px;
                                    }
                                }
                            }
                        }
                    }

                    &:last-child {
                        &>div {
                            &:first-child {
                                color: $TEXT-DARK-COLOR;
                                font-size: 32px;
                                display: flex;
                                justify-content: flex-end;
                                align-items: center;

                                span:first-child {
                                    margin-left: 10px;
                                    font-size: 20px;
                                    width: 100px;
                                    text-align: right;

                                    span {
                                        margin-left: 5px;
                                        font-size: 32px;
                                    }
                                }

                                img {
                                    width: 32px;
                                    height: 32px;
                                }
                            }

                            &:last-child {
                                width: 152px;
                                height: 61px;
                                background: $THEME-COLOR;
                                border-radius: 30px;
                                text-align: center;
                                line-height: 61px;
                                font-size: 26px;
                                color: $TEXT-LIGHT-COLOR;
                                margin-top: 62px;
                            }
                        }
                    }
                }
            }

            &:last-child {
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;

                span {
                    color: #999;
                    font-size: 26px;

                    &:first-child {
                        flex: 1
                    }
                }
            }
        }
    }

    .commonBox {
        padding-bottom: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/page/equipmentAcceptance/equipmentAcceptance.vue